import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Navigation from '../navigation';

import { AbilityContext } from '../utils/ability-context';
import ability from '../abilities';

class RootContainer extends Component {
  render() {
    return (
      <AbilityContext.Provider value={ability(this.props.user)}>
        <Navigation />
      </AbilityContext.Provider>
    );
  }
}

function mapStateToProps({ user }) {
  return { user: user.user };
}

export default withRouter(connect(mapStateToProps, {})(RootContainer));

RootContainer.propTypes = {
  user: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/containers/RootContainer.js